import { InstrumentCategory, stemCategories } from '@arpeggi/shared'
import React, { FC } from 'react'
import { styled } from '../../../lib/stitches'
import { Box, Spacer } from '../../core/Components'
import { ChevronRight } from '../../core/icons'
import CoreText from '../../core/Text/Text'

const Container = styled('div', {
  padding: '13px 0',
  display: 'flex',
  userSelect: 'none'
})

const Text = styled('span', {
  fontSize: '14px',
  lineHeight: '20px',
  fontWeight: 600
})

const Column = styled('div', {
  display: 'inline-flex',
  alignItems: 'center',
  marginRight: '8px',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  variants: {
    width: {
      1: { flex: '1' },
      2: { flex: '2' }
    }
  }
})

const Header: FC = () => (
  <Container css={{ paddingRight: '16px' }}>
    <Column width={2}>
      <Text>{'Title'}</Text>
    </Column>
    <Column width={2}>
      <Text>{'Loops'}</Text>
    </Column>
    <Column width={1}>
      <Text>{'Sample'}</Text>
    </Column>
    <Column width={1}>
      <Text>{'Times used'}</Text>
    </Column>
    <Column width={1} />
  </Container>
)

interface SideNavigationProps {
  selected: InstrumentCategory
  handleClick: (InstrumentCategory: InstrumentCategory) => void
}

const SideNavigation: React.FC<SideNavigationProps> = ({ selected, handleClick }) => (
  <Box css={{ width: '200px', borderRight: '$gray04 solid 1px' }}>
    {Object.keys(stemCategories).map((key: InstrumentCategory) => (
      <SideNavigationItem
        key={key}
        name={key}
        handleClick={() => handleClick(key)}
        isSelected={selected === key}
      />
    ))}
  </Box>
)

const StyledChevronIconRight = styled(ChevronRight, {
  width: '20px',
  color: '$gray08'
})
interface SideNavigationItemProps {
  isSelected: boolean
  handleClick: () => void
  name: string
}

const SideNavigationItem: React.FC<SideNavigationItemProps> = ({
  handleClick,
  isSelected,
  name
}) => (
  <Box
    css={{
      display: 'flex',
      alignItems: 'center',
      padding: '10px 25px',
      backgroundColor: isSelected ? '$gray03' : 'transparent',
      '&:hover': {
        cursor: 'pointer',
        backgroundColor: isSelected ? '$gray03' : '$gray02',
        transition: 'background-color 0.25s ease'
      }
    }}
    onClick={handleClick}
  >
    <CoreText size="16">{name}</CoreText>
    <Spacer />
    <StyledChevronIconRight />
  </Box>
)

const TableWrapper = styled('div', {
  flex: 1,
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch'
})

export { TableWrapper, Header, Column, Container, Text, SideNavigation }
